import { LoadingOutlined } from "@ant-design/icons";
import { notification, Spin } from "antd";
import { Field, Form, Formik } from "formik";
import React, { useState } from "react";

import { brightCoveCredentialValidation } from "../../../utils/validations";

const ThirdPartyIntegration = (props) => {
  const { entityId, fetchBrightCoveToken } = props;
  const [loder, setLoder] = useState(false);
  const [initialState] = useState({
    clientSecret: "",
    clientId: "",
    accountId: "",
  });

  const addbrightCoveCredentials = async ({ clientId, clientSecret, accountId }) => {
    const data = await fetchBrightCoveToken({
      client_id: clientId,
      client_secret: clientSecret,
      account_id: accountId,
      entityId: entityId,
    });

    if (data.value.status) {
      notification["success"]({ message: "BrightCove Credentials updated successfully" });
    } else {
      notification["error"]({ message: "BrightCove Credentials are Invalid" });
    }
  };

  return (
    <>
      <div className="right-container-profile">
        <div className="border-block profile-table-container mt-4" id="createsocialmediaprofile">
          <div className="inner-table-container">
            <div className="title-container-sm row align-items-center">
              <div className="col-md-8">
                <p className="mb-0 large-text">
                  <h5>BrightCove Integration</h5>
                </p>
              </div>
            </div>
            <div className="table-contaier-div">
              <div className="b-row">
                <Formik
                  initialValues={initialState}
                  validationSchema={brightCoveCredentialValidation}
                  onSubmit={addbrightCoveCredentials}
                >
                  {({ errors, touched }) => (
                    <Form>
                      <div>
                        <div className="form-group">
                          <label className="form-label">
                            Client Secret <span className="required">*</span>
                          </label>
                          <Field
                            as="input"
                            className="form-control"
                            name="clientSecret"
                            type="text"
                            placeholder="Enter client secret"
                            style={{ width: 600 }}
                          />
                          {touched.clientSecret && errors.clientSecret && (
                            <div className="invalid-feedback">{errors.clientSecret}</div>
                          )}
                        </div>
                        <div className="form-group">
                          <label className="form-label">
                            Client ID <span className="required">*</span>
                          </label>
                          <Field
                            as="input"
                            className="form-control"
                            name="clientId"
                            type="text"
                            placeholder="Enter client id"
                            style={{ width: 600 }}
                          />
                          {touched.clientId && errors.clientId && (
                            <div className="invalid-feedback">{errors.clientId}</div>
                          )}
                        </div>
                        <div className="form-group">
                          <label className="form-label">
                            Account ID <span className="required">*</span>
                          </label>
                          <Field
                            as="input"
                            className="form-control"
                            name="accountId"
                            type="text"
                            placeholder="Enter account id"
                            style={{ width: 600 }}
                          />
                          {touched.accountId && errors.accountId && (
                            <div className="invalid-feedback">{errors.accountId}</div>
                          )}
                        </div>
                      </div>
                      <button type="submit" className="btn btn-primary">
                        Add
                        {loder == false ? (
                          ""
                        ) : (
                          <Spin
                            size="large"
                            indicator={<LoadingOutlined style={{ fontSize: 50, color: "#000", marginLeft: 50 }} spin />}
                            className="loader__full"
                          ></Spin>
                        )}
                      </button>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ThirdPartyIntegration;
